import { request } from './base'

export async function getPartners() {
  const resp = await request(`/cms/partners`, 'get', {})
  return resp?.data
}
